import styled from 'styled-components'

import { Button, fromMd } from '@syconium/little-miss-figgy'

export const Footer = styled.div<{ $sticky: boolean }>`
  background-color: ${o => o.theme.color.fill.background};
  display: flex;
  flex-direction: column;
  gap: ${o => o.theme.spacing(3)};
  padding: ${o => o.theme.spacing(4, 10)};

  // Only the desktop panel scrolls on its own. On mobile the footer scrolls with everything else
  ${o =>
    o.$sticky &&
    `
    ${fromMd} {
      bottom: 0;
      position: sticky;
    }
  `}
`

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${o => o.theme.spacing(3)};
`

export const StyledButton = styled(Button)`
  width: 100%;
  height: 50px;
`
